import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';

import { usePatchDeploymentConfig } from '@/api/device';
import { WaterType } from '@/api/device/types';
import { useDevice } from '@/api/devices';
import { FRESHWATER_FLUID_DENSITY, SALTWATER_FLUID_DENSITY } from '@/common/convert';
import { Datum } from '@/components/data/Datum';

export const DeploymentConfigSection = ({ readOnly }: { readOnly?: boolean }) => {
    const { mutateAsync: patchDeploymentConfig, isPending } = usePatchDeploymentConfig();
    const { data: device } = useDevice();

    const handleChange = async (waterType: WaterType) => {
        if (!device) {
            console.warn('No Spotter selected');
            return;
        }
        await patchDeploymentConfig({ spotterId: device.spotterId, waterType });
    };

    return (
        <Stack gap={1}>
            <Typography variant="h4">Pressure sensor depth configuration</Typography>
            <Typography>
                Salinity is used to calculate depth from pressure measurements based on estimated fluid density.
            </Typography>
            {device?.deploymentConfig.waterType && (
                <FormControl disabled={isPending || readOnly}>
                    <RadioGroup
                        sx={{ gap: 1 }}
                        defaultValue="Saltwater"
                        value={device.deploymentConfig.waterType}
                        onChange={(event) => {
                            handleChange(event.target.value as WaterType);
                        }}
                    >
                        <FormControlLabel
                            value="Saltwater"
                            sx={{ alignItems: 'start' }}
                            control={<Radio sx={{ mt: '-8px' }} />}
                            label={
                                <Stack sx={{ mt: '3px' }}>
                                    <Typography variant="h5">Saltwater (35 PSU)</Typography>
                                    <Typography>
                                        Fluid density assuming <Datum value={20} sourceUnit="C" type="temperature" />:{' '}
                                        <Datum value={SALTWATER_FLUID_DENSITY} sourceUnit="kg/m^3" type="density" />
                                    </Typography>
                                </Stack>
                            }
                        />
                        <FormControlLabel
                            value="Freshwater"
                            sx={{ alignItems: 'start' }}
                            control={<Radio sx={{ mt: '-8px' }} />}
                            label={
                                <Stack sx={{ mt: '3px' }}>
                                    <Typography variant="h5">Freshwater (0 PSU)</Typography>
                                    <Typography>
                                        Fluid density assuming <Datum value={20} sourceUnit="C" type="temperature" />:{' '}
                                        <Datum value={FRESHWATER_FLUID_DENSITY} sourceUnit="kg/m^3" type="density" />
                                    </Typography>
                                </Stack>
                            }
                        />
                    </RadioGroup>
                </FormControl>
            )}
        </Stack>
    );
};
